<template>
  <div class="FormChangeState">
    <v-btn class="btnDetail" icon x-large dark text @click="openDialog()">
      <v-icon class="mt-2" color="primary">mdi-pencil</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="600" persistent>
      <v-card class="container justify-content-between align-items-center">
        <button class="close-button" @click="closeDialog">
          <span class="small-x">X</span>
        </button>
        <v-col cols="12" md="12" sm="6">
          <img src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png" class="custom-img" />
        </v-col>
        <h2 class="custom-title">{{ $t('reconciliation.label.title') }}</h2>

        <v-row dense>
          <v-col cols="12" md="12" sm="12">
            <div class="custom-state">
              <v-select color="secondary" :label="'*'+$t('reconciliation.label.state.title')" :placeholder="$t('reconciliation.label.state.text')" 
                required :items="typeState" item-text="stateName" item-value="transactionStateId" :rules="typeChangeStateRules"
                v-model="formData.transactionStateId" :disabled="isSubmitting || !formData.isReconcilable"></v-select>
            </div>
            <br>
            <v-textarea v-if="(formData.transactionStateId == 2 || formData.transactionStateId == 3)" color=secondary
              :label="'*'+$t('label.observation.title')" :placeholder="$t('label.observation.text')" v-model="formData.observationMessage" :counter="200" :maxlength="200" required
              :rules="messageRules" outlined :disabled=" isSubmitting || !formData.isReconcilable"></v-textarea>

          </v-col>
          <v-btn large block rounded :color="formData.isReconcilable ? 'primary' : 'grey'"
            class="mb-4 custom-btn" style="color: white; border-radius: 50px;"
            :disabled="isSubmitting || !formData.isReconcilable || formData.transactionStateId == 1 || ((formData.transactionStateId == 2 && formData.observationMessage == null) || (formData.transactionStateId == 3 && formData.observationMessage == null))"
            @click="submitForm()">
            {{ $t('button.save') }}
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import {
  PURCHASERECONCILIATION_M,
  ACCION_GET_CHANGESTATE_LIST_TYPE_STATE,
  GET_CHANGESTATE_LIST_TYPE_STATE,
  ACTION_POST_CHANGESTATE
} from "@/views/purchase_reconciliation/store/types/types.js";

import { mapActions, mapGetters } from 'vuex';
import EventBus from '@/utils/event_bus.js';
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

export default {
  name: "FormChangeState",

  props: {
    postChangeState: {
      required: true
    },
  },
  data() {
    return {
      dialog: false,
      isSubmitting: false,
      formData: {
        transactionId: this.postChangeState.transactionId,
        transactionStateId: this.postChangeState.transactionStateDto.transactionStateId,
        observationMessage: this.postChangeState.observationMessage,
        isReconcilable: this.postChangeState.isReconcilable
      },
      typeChangeStateRules: [
        v => !!v || this.$t('reconciliation.label.state.required')
      ],
      messageRules: [
        v => !!v || this.$t('label.observation.required')
      ],
      showErrorMessages: false
    }
  },

  async mounted() {
    await this.getAccionTypeState();
  },
  watch: {
  postChangeState: {
    handler(newValue) {
      this.formData = {
        transactionId: newValue.transactionId,
        transactionStateId: newValue.transactionStateDto.transactionStateId,
        observationMessage: newValue.observationMessage,
        isReconcilable: newValue.isReconcilable
      };
    },
    deep: true,
    immediate: true
  }
},

  methods: {
    openDialog() {
      this.dialog = true;
    },

    closeDialog() {
      EventBus.$emit('close-dialog');
      this.dialog = false;
      window.location.reload();

    },

    ...mapActions({
      getAccionTypeState: `${PURCHASERECONCILIATION_M}${ACCION_GET_CHANGESTATE_LIST_TYPE_STATE}`,
      putAccionChangeState: `${PURCHASERECONCILIATION_M}${ACTION_POST_CHANGESTATE}`,
    }),

    async submitForm() {

      try {

        const result = await Swal.fire({
          title: i18n.t('label.confirm.title'),
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: i18n.t('button.save.text'),
          cancelButtonText: i18n.t('button.cancel.text'),
          confirmButtonColor: '#6E17A5'
        });

        if (result.isConfirmed) {
          this.isSubmitting = true;
          const validationErrors = this.validateForm();

          if (Object.keys(validationErrors).length > 0) {
            const errorMessages = Object.values(validationErrors).join('<br>');
            Swal.fire({
              icon: 'error',
              title: i18n.t('label.errorsValidation.plural.title'),
              html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
              confirmButtonColor: '#6E17A5'
            });
            return;
          }

          const update = await this.putAccionChangeState(this.formData);
          EventBus.$emit('reload-update-purchaseReconciliation', update.nombre);

          if (!update) {
            this.isSubmitting= false;
            return Swal.fire({
              icon: 'error',
              title: i18n.t('label.invalid.title'),
              text: i18n.t('label.invalid.text')
            });
          }
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'info',
            title: i18n.t('label.delete.cancel'),
            showConfirmButton: false,
            timer: 2500
          });
        }
      } catch (error) {
        console.error(i18n.t('label.failService'), error);
        this.isSubmitting= false;
      }
    },

    validateForm() {
      this.showErrorMessages = true;
      const errors = {};

      if (!this.formData.transactionStateId) {
        errors.transactionStateId = this.$t('reconciliation.label.state.title');
      }

      if (this.formData.transactionStateId == 2 || this.formData.transactionStateId == 3) {
        if (!this.formData.observationMessage) {
          errors.observationMessage = this.$t('label.observation.title');
        }
      }
      return errors;
    },
  },

  computed: {
    ...mapGetters({
      typeState: `${PURCHASERECONCILIATION_M}${GET_CHANGESTATE_LIST_TYPE_STATE}`
    }),
  }

}

</script>

<style lang="css" scoped>
body {
  font-family: 'Nunito Sans', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Amsi Pro', sans-serif;
}

img {
  width: 40vh;
}

.password-match-rule-error {
  color: red;
  font-size: 12px;
}

.small-x {
  font-size: smaller;
}



.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3vh;
  color: #6E17A5;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

.btnDetail .v-icon {
  color: #6E17A5;
  margin-bottom: 42px;
}

.custom-btn {
  border-radius: 50px;
  padding: 12px;
}

.custom-text {
  font-size: 16px;
  color: #000000;
  text-align: center;
  margin: 5px;
}

.custom-state {
  color: #6E17A5;
  text-align: start;
  display: flex;
  padding-right: 100px;
}

.custom-archive {
  color: #6E17A5;
  text-align: start;
}

.custom-img {
  width: 170px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.custom-title {
  color: #6E17A5;
  justify-items: center;
}

@media screen and (max-width: 900px) {
  .row {
    padding-top: 0vh;

  }

  .custom-img {
    width: 100px;
  }

  .custom-title {
    color: #6E17A5;
    justify-items: center;
    font-size: 28px;
  }
}
</style>